import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Image } from '@iho-design-system/Loader';

/*
    - icon
*/
import LoadingCustomSVG from '../assets/images/icons/loading-custom.svg';

const Loading = () => {

    return (
        <Box
            className={`w-100 h-100 position-fixed top-0 left-0`}
            ms={{
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                backdropFilter: 'blur(10px)',
                zIndex: '999'
            }}>
            <Image
                className={`position-absolute transform-center`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        </Box>
    );

}

export default Loading;